import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconMapMarkerSvg } from "./IconMapMarkerSvg.mjs";
const IconMapMarker = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconMapMarkerSvg, ...iconProps });
};
export {
  IconMapMarker
};
